import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import {
  Box,
  Button,
  Autocomplete,
  TextField,
  Tooltip,
  IconButton,
} from "@mui/material";
import { isValidInput } from "../../utils/validations";
import { Tasks, TasksRespnse } from "../../types/General";
import useTranslation from "../../hooks/traslation";
import { useNavigate, useSearchParams } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import {
  SKILLS,
  BOOKING_STATUS,
  NOTIFICATION_TYPE,
  NOTIFICATION_ROLE,
} from "../../utils/enums";
import MainContainer from "../../layout/MainContainer";
import usePermission from "../../hooks/usePermission";
import { showError, showToast } from "../../constants/toasts";
import { useLazyGetTaskQuery } from "../../services/task";
import moment from "moment";
import { useLazyGetTaskListQuery } from "../../services/users";
import {
  useDeleteNotificationByIdMutation,
  useLazyGetHeaderNotificationQuery,
} from "../../services/notification";
import { ConfirmationModal } from "../../Modals/confirmationModal";

type StatusOption = {
  label: string;
  value: number;
};

function RecievedNotifications() {
  const { isAdd, isDelete } = usePermission({
    label: "Manage Notifications",
    page_permission: "isView",
  });

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<number | null>();
  const translation = useTranslation();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState(0);
  const [getTaskById] = useLazyGetTaskListQuery();
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [rows, setRows] = useState<any[]>([]);
  const [selectedId, setSelectedId] = useState<string>("");
  const [openModal, setOpenModal] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [getNotification] = useLazyGetHeaderNotificationQuery();
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [deleteNotification] = useDeleteNotificationByIdMutation();
  const handlePageChange = (event: any, newPage: number) => {
    const updatedPage = newPage + 1;
    setPage(updatedPage);

    const params = new URLSearchParams(window.location.search);
    params.set("page", updatedPage.toString());

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);
  };
  const getNotificationData = async () => {
    try {
      setIsLoading(true);
      const res = await getNotification({
        page,
        limit: limit,
        search: debouncedSearchTerm,
        type: 1,
      }).unwrap();
      if (res.statusCode === 200) {
        setCount(res?.data?.totalNotification);
        setRows(res?.data?.notificationData || []);
      }
    } catch (error: any) {
      showError(error?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  //delete Notification
  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await deleteNotification({
        id: selectedId || "",
      }).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast("notification deleted");
        if (rows.length === 1 && page > 1) {
          setPage(page - 1);
        } else {
          getNotificationData();
        }
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    }
  };

  const columns: GridColDef<any>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 200,
      field: "message",
      headerName: "Message",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 150,
      field: "createdAt",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      valueGetter: (params) =>
        moment(params.row.createdAt).format("DD MMMM YYYY, hh:mm A"),
    },
    {
      minWidth: 100,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            {isDelete ? (
              <Box>
                <Tooltip title="Delete">
                  <IconButton
                    onClick={() => {
                      setSelectedId(row?._id);
                      setOpenDelete(true);
                    }}
                  >
                    <img src="/static/images/trash2_icon.svg" alt="" />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : null}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getNotificationData();
  }, [debouncedSearchTerm, page, limit]);
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Recieved Notifications</h1>
        <div className="cards">
          <Box
            className="search_box"
            style={{ marginBottom: "20px", display: "flex", gap: "20px" }}
          >
            <SearchBar
              placeholder={translation.user.SearchHere}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={isLoading}
            />
            {rows.length !== 0 && (
              <div className="table_footer">
                <div className="pagination_info">
                  <span className="total_records">Showing {rows.length} of {count} records</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ConfirmationModal
        text={"Are you sure you want to delete this Notification"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </MainContainer>

    // </CustomTabPanel>
  );
}

export default RecievedNotifications;
